import React, { Component } from "react";
import { connect } from "react-redux";
import {
  deleteEmailSchedule,
  getEmailSchedules,
} from "../../../store/actions";
import '../style.scss';
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "../../../assets/images/ionic-ios-add-circle-outline.png";
import { numberedWeekDays, timeFrames as getTimeFrames } from "../../../utils/constants";
import permissionList from '../../../assets/data/permissionList.json';
import Loader from "../../../components/loader";
import { ConfirmationPopUp } from "../../../components/confirmation";
import Portal from "../../../components/portal";
import AddSchedule from "./AddSchedule";

class EmailScheduleView extends Component {
  state = {
    createdBy: "",
    daysOfWeek: [],
    isEditSchedule: false,
    editScheduleData: null,
    loading: true,
    reportsList: [],
    scheduleUpdated: false,
    schedules: [],
    scheduleId: "",
    showConfirmationBox: false,
    showAddSchedule: false,
    timeFrames: [],
  };

  async componentDidMount() {
    this.populateTime();
    let schedules = await this.getSchedules(this.props.UserReducer.companyId || this.props.UserReducer.companyDetails._id);
    let isAdminLogin = this.props.UserReducer.companyDetails.companyType === 'Admin' && !this.props.UserReducer.LOGIN_AS;
    let portal = isAdminLogin ? 'Admin' : 'Client';
    let createdBy = this.props.UserReducer.LOGIN_AS ? 'Admin' : this.props.UserReducer.username;
    let reportsList = permissionList.filter(perm => {
      let isActive = this.props.UserReducer.permissions.find(pr => pr.isActive && pr.key === perm.key);
      return perm.group === 'REPORTS' && portal === perm.portal && isActive;
    });

    let daysOfWeek = numberedWeekDays;

    this.setState({
      schedules: schedules || [],
      loading: false,
      reportsList,
      createdBy,
      daysOfWeek,
    });
  };

  async componentDidUpdate() {
    if (this.state.scheduleUpdated) {
      let schedules = await this.getSchedules(this.props.UserReducer.companyId || this.props.UserReducer.companyDetails._id);
      this.setState({
        schedules,
        scheduleUpdated: false,
      });
    };
  };

  getSchedules = async compId => {
    return getEmailSchedules(compId);
  };

  populateTime = async () => {
    const timeFrames = getTimeFrames();
    this.setState({ timeFrames })
  };

  btnEditSchedule = async (schedule) => {
    this.setState({
      editScheduleData: schedule,
      showAddSchedule: true,
      isEditSchedule: true
    });
  };

  toggleConfirmationPopup = () => {
    this.setState({ showConfirmationBox: false });
  };

  confirmationPopupOpen = (_id) => {
    this.setState({ showConfirmationBox: true, scheduleId: _id });
  };

  btnDeleteSchedule = async () => {
    if (!this.state.scheduleId) return;
    let result = await deleteEmailSchedule(this.state.scheduleId);
    if (result && result.statusText === "OK") {
      this.setState({
        showConfirmationBox: false,
        scheduleUpdated: true,
        scheduleId: ""
      });
    };
  };


  displaySchedule = schedule => {
    let { scheduleStartDate,
      scheduleFrequency,
      scheduleDaysOfMonth,
      scheduleDaysOfWeek,
      scheduleDeliveryTime,
    } = schedule;

    switch (scheduleFrequency) {
      case "Daily": return `${scheduleFrequency} @${this.state.timeFrames.find(tf => tf.value === scheduleDeliveryTime).label}`;
      case "Weekly": return `${scheduleFrequency} 
      on ${scheduleDaysOfWeek.map(d => this.state.daysOfWeek[d].label + ' ')}
      @${this.state.timeFrames.find(tf => tf.value === scheduleDeliveryTime).label}`;
      case "Monthly": return `${scheduleFrequency} 
      on the ${scheduleDaysOfMonth.map(d => this.pickOrdinalIndicator(d) + ' ')}
      @${this.state.timeFrames.find(tf => tf.value === scheduleDeliveryTime).label}`;
      case "Quarterly": return `${scheduleFrequency} 
      on the ${this.pickOrdinalIndicator(new Date(scheduleStartDate).getDate())} 
      @${this.state.timeFrames.find(tf => tf.value === scheduleDeliveryTime).label}`;
    };
  };

  pickOrdinalIndicator = i => {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    };
    if (j == 2 && k != 12) {
      return i + "nd";
    };
    if (j == 3 && k != 13) {
      return i + "rd";
    };
    return i + "th";
  };

  onHide = (scheduleUpdated) => {
    //reset modal values
    this.setState({
      isEditSchedule: false,
      editScheduleData: null,
      scheduleUpdated,
      showAddSchedule: false
    });

  };


  render() {
    const {
      isEditSchedule,
      loading,
      reportsList,
      schedules,
    } = this.state;

    return (
      <>
        <div className="table-header d-flex align-items-center justify-content-between">
          <button className="add_order" onClick={() => this.setState({ showAddSchedule: true })}>
            <img src={AddIcon} alt="" /> Add
          </button>
        </div>
        <div className="shadow_white_box full-box mt-0" style={{ minHeight: '50vh' }}>
          <div className="row">
            {loading ? (
              <div className="loading-data d-flex align-items-center justify-content-center">
                <Loader></Loader>
              </div>
            ) : (
              <>
                {schedules.length === 0 && (<div className="no-data">Your email schedules will appear here</div>)}
                {schedules.map((schedule, i) => (
                  <div className="col-4" key={i}>
                    <div className="emailColumn">
                      <div className="email-box">
                        <div className="row align-items-center justify-content-between">

                          <div className="col-12">
                            <div className="email-filed">
                              <div className="emailLabel">
                                Schedule Date & Time
                              </div>
                              <div className="emailTime timeBg">
                                {this.displaySchedule(schedule)}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-center justify-content-between mt-3">
                          <div className="col-6">
                            <div className="email-filed">
                              <div className="emailLabel">Report</div>
                              <div className="reportName">{reportsList.find(el => el.key === schedule.reportName)?.label}</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="email-filed">
                              <div className="emailLabel ">
                                Created By
                                <div className="reportName">
                                  <span className={`CrRole timeBg ${schedule.createdBy === "Admin" ? "admin_color" : "client_color"}`}>
                                    {schedule.createdBy}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="action">
                        <button
                          className="btn btn-primary"
                          onClick={() => this.btnEditSchedule(schedule)}
                        >
                          <EditIcon />
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={() => this.confirmationPopupOpen(schedule._id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        {this.state.showConfirmationBox && (
          <Portal
            zIndex="101"
            height="164px"
            width="424px"
            close={this.toggleConfirmationPopup}
            title="Confirmation"
          >
            <ConfirmationPopUp
              message="Are you sure you want to delete this Email Schedule?"
              id={this.state.id}
              close={this.toggleConfirmationPopup}
              confirmation={this.btnDeleteSchedule}
            ></ConfirmationPopUp>
          </Portal>
        )}
        {this.state.showAddSchedule && (
          <AddSchedule
            isEditSchedule={isEditSchedule}
            editScheduleData={this.state.editScheduleData}
            onClose={(scheduleUpdated) => {
              this.onHide(scheduleUpdated)
            }}
            reportsList={reportsList}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = ({ UserReducer, InventoryItemsReducer, ClientDataReducer }) => ({
  UserReducer,
  InventoryItemsReducer,
  ClientDataReducer,
});
export default connect(mapStateToProps, {

})(EmailScheduleView);
